<template>
    <div class="image-hotspots">
        <div class="image-frame"
             :class="{'show-content': activeSpot}"
        >
            <img :src="content.image.content" />

            <div
                class="image-spot"
                v-for="spot in content.spots"
                :style="{
                    left: spot.attributes.x,
                    top: spot.attributes.y,
                    width: spot.attributes.width,
                    height: spot.attributes.height
                }"
                :class="{'bordered': spot.attributes.border}"
                @click="activeSpot = spot"
            >
                <div v-if="spot.attributes.icon" class="icon">
                    <i class="fas fa-plus-circle"></i>
                </div>
            </div>

            <div v-if="activeSpot" class="image-spot-content" @click="activeSpot=null">
                <render-editor-js :content="activeSpot.content" :component="{}"/>
                <div class="close-content"><i class="fas fa-times"></i></div>
            </div>
        </div>
    </div>
</template>

<script>
    import RenderEditorJs from "./RenderEditorJs";

    export default {
        props: ['content'],
        components: {RenderEditorJs},
        data: function () {
            return {
                activeSpot: null
            };
        },
        methods: {

        }
    };
</script>

<style lang="scss" scoped>
    .image-hotspots {
        .image-frame {
            margin: 10px 2rem 2rem;
            position: relative;

            img {
                transition: filter 0.3s ease; /* Smooth transition for the blur effect */
                display: block;
            }

            .image-spot {
                position: absolute;
                border-radius: 5px;
                cursor: pointer;
                transition: background-color 0.3s ease;

                &:hover {
                    background-color: rgba(255,255,255,0.2);

                    .icon {
                        color: rgba(255,255,255,1);
                    }
                }

                &.bordered {
                    border: 2px solid #336699;
                }

                .icon {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    color: rgba(255,255, 255, 0.6);
                    font-size: 3.5rem;
                    transition: color 0.3s ease;
                }
            }

            .image-spot-content {
                position: absolute;
                background-color: rgba(255, 255, 255, 0.85);
                display: none;
                padding: 2rem;
                left: 12px;
                right: 12px;
                top: 12px;
                bottom: 8px;
                overflow-x: hidden;
                overflow-y: auto;
                border-radius: 5px;

                .close-content {
                    position: absolute;
                    top: 12px;
                    right: 25px;
                    cursor: pointer;
                    color: #333;
                    font-size: 2rem;

                    &:hover {
                        color: #666;
                    }
                }
            }

            &.show-content {
                img {
                    filter: blur(8px);
                }

                .image-spot {
                    display: none;
                }

                .image-spot-content {
                    display: block;
                }
            }

        }


    }

</style>
